import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Box, Modal, Stack } from '@mui/material';

import type { ModalProps, SxProps } from '@mui/material';

export type EliceModalProps = {
  open: boolean;
  handleClose: () => void;
  iconClose?: boolean;
  fontFamily?: string;
  sx?: SxProps;
} & ModalProps;

const EliceModal = (props: EliceModalProps) => {
  const {
    open,
    handleClose,
    children,
    iconClose = false,
    sx = {},
  } = props;
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={[
          {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: '95vw',
            maxHeight: '95vh',
            minWidth: '80vw',
            bgcolor: '#F4F6FF',
            borderRadius: '2.6rem',
            padding: '2.4rem 3.2rem 2.4rem 3.2rem',
            outline: 'none',
          },
          sx,
        ] as any}
      >
        {iconClose && (
          <Stack
            display="flex"
            position="relative"
            justifyContent="flex-end"
            zIndex={1200}
            alignItems="flex-end"
            onClick={handleClose}
          >
            <HighlightOffIcon
              sx={{
                width: '2.7rem',
                height: '2.7rem',
                cursor: 'pointer',
              }}
              color="secondary"
            />
          </Stack>
        )}
        {children}
      </Box>
    </Modal>
  );
};

export default EliceModal;
